import script from "./WishesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WishesSection.vue?vue&type=script&setup=true&lang=js"

import "./WishesSection.vue?vue&type=style&index=0&id=ff2176b8&lang=css"

const __exports__ = script;

export default __exports__